import AppHsForm from "./application/components/AppHsForm";
import PortalVue from "portal-vue";
import { createApp } from "vue";
import router from "./application/utils/router";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";

const pinia = createPinia();

const app = createApp(AppHsForm);

const sentryDSN = (process.env.NODE_ENV === 'development') ?
    'http://sentry@localhost:23517/1' :
    'https://2b07b4cc1dc84d008533743570d178c4@o401565.ingest.sentry.io/4504751449178112';

Sentry.init({
    app,
    environment: process.env.NODE_ENV,
    dsn: sentryDSN,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [Sentry.replayIntegration()],
});

app.use(router)
    .use(pinia)
    .use(PortalVue)
    .mount("#hsapp");
